module.exports = __webpack_public_path__ + "img/openInterest.5da1bdb1.png";